import { registerI18nResources } from '@mc/i18n'
import enUS from './locales/en-US.json'

export const CORE_MEMBERSHIP_LANGUAGE_CLEANUP_I18N_NAMESPACE =
  '@mc/next/experiments/core-membership-language-cleanup'

export const i18nInstance = registerI18nResources({
  namespace: CORE_MEMBERSHIP_LANGUAGE_CLEANUP_I18N_NAMESPACE,
  resources: { 'en-US': enUS },
})
